<ifc-base-dialog [title]="failureFiles.length ? 'Unable to complete' : 'Just a moment...'"
                 [actions]="failureFiles.length ? actionsInfo : actionsProgress"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <div class="progress" *ngIf="!failureFiles.length">
      <p>Sometimes a little more time is needed when handling multiple files.</p>
      <mat-progress-bar class="progress__bar" mode="determinate" [value]="progressValue"></mat-progress-bar>
    </div>
    <div class="info" *ngIf="failureFiles.length">
      <p>We encountered an error while handling the files below. Give it another try. If the problem persist reach out to us at {{phoneNumber}}</p>
      <div>
        <p class="info__file" *ngFor="let file of failureFiles">{{file?.name}}</p>
      </div>
    </div>
  </ng-template>
</ifc-base-dialog>
